export default class Employee {
    constructor(opts) {
        this.age = 0;
        this.hoursPerDay = 7.5;
        this.daysPerWeek = 5;
        this.pensionContribution = 0;
        this.studentLoanType = '';
        this.isMarried = false;
        this.isBlind = false;
        this.isPensioner = false;

        if ('age' in opts) {
            this.age = opts.age;
        }

        if ('hoursPerDay' in opts) {
            this.hoursPerDay = opts.hoursPerDay;
        }

        if ('daysPerWeek' in opts) {
            this.daysPerWeek = opts.daysPerWeek;
        }

        if ('pensionContribution' in opts) {
            this.pensionContribution = opts.pensionContribution;
        }

        if ('studentLoanType' in opts) {
            this.studentLoanType = opts.studentLoanType;
        }

        if ('isMarried' in opts) {
            this.isMarried = opts.isMarried;
        }

        if ('isBlind' in opts) {
            this.isBlind = opts.isBlind;
        }

        if ('isPensioner' in opts) {
            this.isPensioner = opts.isPensioner;
        }
    }
}